/* lock.icon.svg.js */

"use strict";
module.exports = {
    icon: `
        <svg viewBox="0 0 12.4 16" preserveAspectRatio="none">
        <path class="foreground-gl" d="M0,8.3l0,7C0,15.7,0.3,16,0.7,16h10.9c0.4,0,0.7-0.3,0.7-0.7v-7c0-0.4-0.3-0.7-0.7-0.7h-0.4V4.7
            C11.2,2.1,9,0,6.2,0c-2.8,0-5,2.1-5.1,4.7c0,0,0,2.1,0,2.9H0.7C0.3,7.6,0,8,0,8.3z M9,7.6H3.4V4.7c0.1-1.4,1.3-2.5,2.8-2.5
            c1.5,0,2.7,1.1,2.8,2.5h0V7.6z M5.5,11.6c-0.4-0.2-0.6-0.6-0.6-1c0-0.6,0.5-1.1,1.2-1.1c0.7,0,1.2,0.5,1.2,1.1c0,0.4-0.2,0.8-0.6,1
            c0,0,0,0,0,0l0.4,2.1c0,0.3-0.7,0.6-1,0.6h0c-0.3,0-1-0.2-1-0.6L5.5,11.6C5.5,11.6,5.5,11.6,5.5,11.6z"/>
        </svg>`,
    toggledIcon: `
        <svg viewBox="0 0 18.3 16" preserveAspectRatio="none">
        <path class="foreground-gl" d="M11.7,7.6h-1.3V4.7h0c0.1-1.4,1.3-2.5,2.8-2.5c1.5,0,2.7,1.1,2.8,2.5v3.4c0,0-0.1,0.4,0.4,0.4c0.3,0,1,0,1.5,0
            c0.4,0,0.4-0.3,0.4-0.4c0-0.1,0-3.4,0-3.4C18.2,2.1,16,0,13.2,0c-2.8,0-5,2.1-5.1,4.7v2.9H7.7h-7C0.3,7.6,0,8,0,8.3v7
            C0,15.7,0.3,16,0.7,16h10.9c0.4,0,0.7-0.3,0.7-0.7v-7C12.4,8,12.1,7.6,11.7,7.6z M6.7,11.6l0.4,2.1c0,0.3-0.7,0.6-1,0.6h0
            c-0.3,0-1-0.2-1-0.6l0.4-2.1c0,0,0,0,0,0c-0.4-0.2-0.6-0.6-0.6-1c0-0.6,0.5-1.1,1.2-1.1c0.7,0,1.2,0.5,1.2,1.1
            C7.3,11,7,11.4,6.7,11.6C6.7,11.6,6.7,11.6,6.7,11.6z"/>
        </svg>`,
};
